import parse from 'html-react-parser';

const SortableColumnHeader = (params) => {
  const {
    isSortable = true,
    apiParams,
    setApiParams,
    columnId = -1,
    headerName
  } = params
  const indexOfThisColumn = apiParams.sortingCols.findIndex(item => item[0] === columnId)
  const sortingArrowFillColor = "rgba(255,255,255,0.75)"

  const handleSort = () => {
    if (!isSortable) return;
    setApiParams(oldParams => {
      let prevOrder = [...oldParams.sortingCols]

      // START SINGLE COLUMN SORTING LOGIC
      if (prevOrder.length > 0 && prevOrder[0][0] === columnId) {
        if (prevOrder[0][1] === 'ASC') prevOrder[0][1] = 'DESC'
        else if (prevOrder[0][1] === 'DESC') prevOrder = [];
      }
      else {
        prevOrder[0] = [columnId, 'ASC']
      }
      // END SINGLE COLUMN SORTING LOGIC

      return { ...oldParams, sortingCols: prevOrder }
    })
  }

  return (
    <>
      <div
        onClick={handleSort}
        className='customFieldHeader'
        style={{ cursor: isSortable ? 'pointer' : 'default', color: '#ffffff' }}
      >
        <span>
          {parse(headerName)}
          {apiParams.filterCols.find(obj => obj.colId === columnId) ? '*' : ""}
          &nbsp;
        </span>
        <span>
          {isSortable && indexOfThisColumn === -1 &&
            <svg width="10" height="16" style={{ verticalAlign: 'middle' }}>
            <polygon points="5,0 0,6 10,6" fill={sortingArrowFillColor} />   // Up triangle
            <polygon points="5,16 0,10 10,10" fill={sortingArrowFillColor} /> // Down triangle
          </svg>
          }
          {isSortable && indexOfThisColumn !== -1 && apiParams.sortingCols[indexOfThisColumn][1] === 'ASC' &&
            <svg  width="10" height="16">
              {/* Up Triangle */}
              <polygon points="5,0 0,14 10,14" fill={sortingArrowFillColor} />
            </svg>
          }
          {isSortable && indexOfThisColumn !== -1 && apiParams.sortingCols[indexOfThisColumn][1] === 'DESC' &&
            <svg  width="10" height="16" >
              {/* Down Triangle */}
              <polygon points="5,30 0,16 10,16" fill={sortingArrowFillColor} />
            </svg>
          }
        </span>
      </div>
    </>
  )
}

export default SortableColumnHeader
